import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkFixingImplEncoder } from "../../encoder/BenchmarkFixingImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkFixing } from "../BenchmarkFixing";

export class BenchmarkFixingImpl extends ConcreteEncodable implements BenchmarkFixing {
  public static enType: string = "com.bcdfx.model.BenchmarkFixingImpl";

  /*FID=1*/
  public benchmarkCd: string;
  /*FID=2*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=3*/
  public benchmarkDesc: string;
  /*FID=4*/
  public rateSourceCd: string;
  /*FID=5*/
  public softCutoffOffset: CubiqTS.Long | null = null;
  /*FID=6*/
  public hardCutoffOffset: CubiqTS.Long | null = null;
  /*FID=7*/
  public sweepTimeOffset: CubiqTS.Long | null = null;
  /*FID=8*/
  public deletedFg: boolean;
  /*FID=9*/
  public fixingFillTypeId: CubiqTS.FixingFillType;
  /*FID=10*/
  public aliases: Array<string> | null = null;
  /*FID=11*/
  public rules: Array<CubiqTS.BenchmarkFixingRule> | null = null;
  /*FID=12*/
  public traderVisibilityOffset: CubiqTS.Long | null = null;
  /*FID=13*/
  public effectiveTraderVisibilityOffset: CubiqTS.Long | null = null;
  /*FID=14*/
  public preHCOOffset: CubiqTS.Long | null = null;
  /*FID=15*/
  public preHedgeOffset: CubiqTS.Long | null = null;
  /*FID=16*/
  public preHedgeFreq: CubiqTS.Long | null = null;
  /*FID=17*/
  public enableExternalRiskRoutingFg: boolean;
  /*FID=18*/
  public benchmarkPairConfigs: Array<CubiqTS.BenchmarkPairConfig> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkFixingImplEncoder.Instance;
    this.setEncodableType(BenchmarkFixingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkFixingImpl[" +
      "benchmarkCd=" +
      this.benchmarkCd +
      "stamp=" +
      this.stamp +
      "benchmarkDesc=" +
      this.benchmarkDesc +
      "rateSourceCd=" +
      this.rateSourceCd +
      "softCutoffOffset=" +
      this.softCutoffOffset +
      "hardCutoffOffset=" +
      this.hardCutoffOffset +
      "sweepTimeOffset=" +
      this.sweepTimeOffset +
      "deletedFg=" +
      this.deletedFg +
      "fixingFillTypeId=" +
      this.fixingFillTypeId +
      "aliases=" +
      this.aliases +
      "rules=" +
      this.rules +
      "traderVisibilityOffset=" +
      this.traderVisibilityOffset +
      "effectiveTraderVisibilityOffset=" +
      this.effectiveTraderVisibilityOffset +
      "preHCOOffset=" +
      this.preHCOOffset +
      "preHedgeOffset=" +
      this.preHedgeOffset +
      "preHedgeFreq=" +
      this.preHedgeFreq +
      "enableExternalRiskRoutingFg=" +
      this.enableExternalRiskRoutingFg +
      "benchmarkPairConfigs=" +
      this.benchmarkPairConfigs +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
